'use client';

import { Suspense, use, useEffect } from 'react';
import { useSetAtom } from 'jotai';
import { usePathname } from 'next/navigation';

import { languageAlternatesAtom } from '@packages/modules/src/Header/MetaNavigation/shared/useLocaleSwitch.atom';
import { usePRankOptinTracking } from '@packages/search/src/hooks/usePRankTracking';

// Suspends until the navigation request resolves, then writes the alternate
// localized links to the locale-switch atom.
const AlternateLinksEffect = ({
  alternateLinksPromise,
}: {
  alternateLinksPromise: Promise<Record<string, string> | undefined>;
}) => {
  const alternateLinks = use(alternateLinksPromise);
  const pathname = usePathname();
  const setLanguageAlternates = useSetAtom(languageAlternatesAtom);

  useEffect(() => {
    setLanguageAlternates({
      currentPathname: pathname ?? 'unknown',
      alternateLinks,
    });
  }, [alternateLinks, pathname, setLanguageAlternates]);

  return null;
};

export const CategoryPageEffects = ({
  alternateLinksPromise,
}: {
  alternateLinksPromise: Promise<Record<string, string> | undefined>;
}) => {
  // pRank A/B test: Send OPTIN: 1 once per category page entry. It must not
  // be delayed by the navigation request, so it stays outside the Suspense below.
  usePRankOptinTracking();

  return (
    <Suspense fallback={null}>
      <AlternateLinksEffect alternateLinksPromise={alternateLinksPromise} />
    </Suspense>
  );
};
